import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsRecoveryFreespins extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        const isRecovery = GameState.getCurrentGame().isRecovered;
        const isFreespins = record && (record instanceof FreespinRecord || record.freespinsTriggered);

        return isRecovery && isFreespins ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/is-recovery-freespins.ts